export default "__VITE_ASSET__b9falZD$__"